/* eslint-disable wrap-iife */
(function($) {
  'use strict';

  var $colListItems = $('.column-list__item');

  $colListItems.each(function () {
    var $item = $(this);
    if ($item.text().trim().length === 0) {
      $item.remove();
    }
  });

})(jQuery);
